import { h } from '@stencil/core';
import cn from 'classnames';
import { VIEW_ON_PLACEHOLDER, EQdsButtonImportance, EQdsButtonSize } from '@pes-ui/utils';
import isEmpty from 'lodash/isEmpty';
import { isTopRunner } from '../../guards';
import { VARIANTS, CARD_NAME_MAX_HEIGHT_VARIANT_MAP, CARD_DESCRIPTION_MAX_HEIGHT_VARIANT_MAP, } from '../constants';
import RouterLinkView from '../../router-link-view';
import RouterQdsLinkView from '../../router-qds-link-view';
import { isAppRoutingEnabled } from '../../../pes-router/utils';
export class MenuCard {
  handleMenuCategoryActive(event) {
    var _a, _b;
    const activeCategoryId = event.detail;
    if (activeCategoryId === this.categoryId) {
      (_a = this.descriptionEllipsisRef) === null || _a === void 0 ? void 0 : _a.triggerUpdate();
      (_b = this.nameEllipsisRef) === null || _b === void 0 ? void 0 : _b.triggerUpdate();
    }
  }
  constructor() {
    this.createDescriptionEllipsisRef = (el) => {
      this.descriptionEllipsisRef = el;
    };
    this.createNameEllipsisRef = (el) => {
      this.nameEllipsisRef = el;
    };
    this.page = undefined;
    this.item = undefined;
    this.categoryId = undefined;
    this.productsFeed = undefined;
    this.viewAllTemplate = undefined;
    this.showViewAll = false;
    this.productRelationsViewProdLabel = undefined;
    this.variant = VARIANTS.DEFAULT;
    this.commerceConnectorSettings = undefined;
    this.breadcrumbs = undefined;
    this.storageName = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  hasCommercialStatus(item) {
    return !isEmpty(item === null || item === void 0 ? void 0 : item.commercialStatus) && !!item.commercialStatus.label;
  }
  render() {
    var _a, _b, _c, _d;
    const pageId = (_a = this.item.sourceId) !== null && _a !== void 0 ? _a : this.item.id;
    const redirectUrl = isTopRunner(this.item)
      ? this.item.redirectUrl
      : undefined;
    const { url } = this.item;
    const isTopRunnerWithDefaultVariant = isTopRunner(this.item)
      && this.variant === VARIANTS.DEFAULT;
    const viewAllLinkLabel = redirectUrl
      ? (_b = this.viewAllTemplate) === null || _b === void 0 ? void 0 : _b.replace(VIEW_ON_PLACEHOLDER, this.item.domainName)
      : this.productRelationsViewProdLabel;
    return (h("div", { class: cn('menu-card', `menu-card--${this.variant}`) }, h(RouterLinkView, { linkClassName: "menu-card__link", page: this.page, pageId: pageId, url: isAppRoutingEnabled() ? '' : redirectUrl || url, target: redirectUrl ? '_blank' : '_self', name: this.item.name, storageName: this.storageName, breadcrumbs: this.breadcrumbs, pageName: this.page.toLocaleUpperCase() }, h("img", { class: "menu-card__picture", src: this.item.pictureUrl, alt: "" }), h("div", { class: "menu-card__text-content" }, h("span", { class: "menu-card__name" }, h("pes-ellipsis", { ref: this.createNameEllipsisRef, maxHeight: CARD_NAME_MAX_HEIGHT_VARIANT_MAP[this.variant], content: this.item.name })), this.hasCommercialStatus(this.item) && (h("pes-badge-wrapper", { class: "menu-card__badge", type: this.item.commercialStatus.status, label: this.item.commercialStatus.label, color: this.item.commercialStatus.color })), ((_c = this.item.badge) === null || _c === void 0 ? void 0 : _c.label) && (h("pes-badge-wrapper", { class: "menu-card__badge", type: this.item.badge.type, label: this.item.badge.label })), h("p", { class: "menu-card__description" }, h("pes-ellipsis", { ref: this.createDescriptionEllipsisRef, maxHeight: CARD_DESCRIPTION_MAX_HEIGHT_VARIANT_MAP[this.variant], content: this.item.description })), this.variant === VARIANTS.SMALL && (h("pes-menu-card-prices", { item: this.item, productsFeed: this.productsFeed, commerceConnectorSettings: this.commerceConnectorSettings }))), isTopRunner(this.item)
      && this.item.brandLogo && (h("img", { class: "menu-card__brand-image", src: this.item.brandLogo.absoluteUrl, alt: (_d = this.item.brandLogo.alt) !== null && _d !== void 0 ? _d : '' }))), isTopRunnerWithDefaultVariant && (h("div", { class: "menu-card__view-all", title: viewAllLinkLabel }, h(RouterQdsLinkView, { linkClassName: "menu-card__view-all-link", page: this.page, pageId: pageId, url: isAppRoutingEnabled() ? '' : redirectUrl || url, target: redirectUrl ? '_blank' : '_self', size: EQdsButtonSize.SMALL, importance: redirectUrl
        ? EQdsButtonImportance.STANDARD
        : EQdsButtonImportance.EMPHASIZED, iconName: redirectUrl ? "arrow-top-right-on-square" : '', name: this.item.name, storageName: this.storageName, breadcrumbs: this.breadcrumbs, pageName: this.page.toLocaleUpperCase() }, viewAllLinkLabel)))));
  }
  static get is() { return "pes-menu-card"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["menu-card.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["menu-card.css"]
    };
  }
  static get properties() {
    return {
      "page": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "PesPageType",
          "resolved": "\"\" | \"all-products\" | \"category\" | \"comparator\" | \"product\" | \"product-cart\" | \"range\" | \"subcategory\"",
          "references": {
            "PesPageType": {
              "location": "import",
              "path": "../../../../globals/types"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "page",
        "reflect": false
      },
      "item": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "| CategoriesApi.ProductsAllToprunners\n  | CategoriesApi.ProductsAllCategoriesCategoryProduct",
          "resolved": "{ brandImageUrl?: string; brandImageAltText?: string; badge?: Badge; count?: number; description?: string; domainName?: string; id?: string; longDescription?: string; name?: string; pictureUrl?: string; redirectUrl?: string; simpleName?: string; smallPictureUrl?: string; sourceId?: string; type?: string; url?: string; commercialStatus?: CommercialStatus; brandLogo?: TBrandLogo; } | { currency?: string; description?: string; id?: string; longDescription?: string; name?: string; pictureUrl?: string; price?: number; pimpleName?: string; sourceId?: string; type?: string; url?: string; badge?: Badge; weeePrices?: WEEEPrices; commercialStatus?: CommercialStatus; }",
          "references": {
            "CategoriesApi": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "categoryId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "category-id",
        "reflect": false
      },
      "productsFeed": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "ProductsFeed",
          "resolved": "FeedProduct[]",
          "references": {
            "ProductsFeed": {
              "location": "import",
              "path": "../../../commerce-connector/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "viewAllTemplate": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "view-all-template",
        "reflect": false
      },
      "showViewAll": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-view-all",
        "reflect": false,
        "defaultValue": "false"
      },
      "productRelationsViewProdLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "product-relations-view-prod-label",
        "reflect": false
      },
      "variant": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "TItemVariants",
          "resolved": "\"default\" | \"small\"",
          "references": {
            "TItemVariants": {
              "location": "import",
              "path": "../types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "variant",
        "reflect": false,
        "defaultValue": "VARIANTS.DEFAULT"
      },
      "commerceConnectorSettings": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "CommerceConnectorSettings",
          "resolved": "{ options: CommerceConnectorOptions; labels: CommerceConnectorLabels; messages: CommerceConnectorMessages; }",
          "references": {
            "CommerceConnectorSettings": {
              "location": "import",
              "path": "../../../commerce-connector/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "breadcrumbs": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TBreadcrumbs[]",
          "resolved": "TBreadcrumbs[]",
          "references": {
            "TBreadcrumbs": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "breadcrumbs array for saving in indexDB"
        }
      },
      "storageName": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "storageName in indexDB for saving breadcrumbs"
        },
        "attribute": "storage-name",
        "reflect": false
      }
    };
  }
  static get elementRef() { return "el"; }
  static get listeners() {
    return [{
        "name": "pdpMenuCategoryDidOpen",
        "method": "handleMenuCategoryActive",
        "target": "document",
        "capture": false,
        "passive": false
      }];
  }
}
